import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const PASSI = {
  iphone: {
    label: "iPhone / iPad",
    steps: [
      "Apri questa pagina dall'iPhone (dall'icona EFFERRE sulla schermata Home o da Safari).",
      "Tocca il pulsante arancione «Collega a iPhone / Mac».",
      "Compare la richiesta «Iscriviti al calendario»: tocca Iscriviti, poi Aggiungi (o Fine).",
      "Apri l'app Calendario: trovi il calendario «EFFERRE Photo – …» con tutti gli eventi.",
    ],
    extra: "Se il pulsante non funziona: copia il link, poi vai in Impostazioni › App › Calendario › Account Calendario › Aggiungi account › Altro › Aggiungi calendario sottoscritto, incolla il link e tocca Avanti › Salva. Per aggiornamenti più rapidi: Impostazioni › App › Calendario › Account Calendario › Scarica nuovi dati › Ogni 15 minuti.",
  },
  mac: {
    label: "Mac",
    steps: [
      "Apri questa pagina dal Mac e clicca «Collega a iPhone / Mac»: si apre l'app Calendario.",
      "Conferma con Iscriviti.",
      "In «Posizione» scegli iCloud: così il calendario compare da solo anche su iPhone e iPad.",
      "In «Aggiornamento automatico» scegli «Ogni 5 minuti» o «Ogni 15 minuti», poi OK.",
    ],
    extra: "In alternativa: app Calendario › menu Archivio › Nuova iscrizione a calendario… › incolla il link › Iscriviti.",
  },
  android: {
    label: "Android / Google",
    steps: [
      "Il collegamento si fa una sola volta, meglio da computer: l'app Google Calendar sul telefono non permette di aggiungere calendari tramite link.",
      "Clicca «Aggiungi a Google Calendar» ed entra con lo stesso account Google che usi sul telefono, poi conferma con Aggiungi.",
      "Sul telefono apri Google Calendar › menu ☰ › Impostazioni › tocca il calendario «EFFERRE Photo – …» › attiva Sincronizzazione.",
      "Gli eventi compaiono anche nel Calendario Samsung se ci hai collegato lo stesso account Google.",
    ],
    extra: "Senza pulsante: vai su calendar.google.com › «+» accanto ad «Altri calendari» › Da URL › incolla il link › Aggiungi calendario. Nota: Google aggiorna i calendari collegati ogni qualche ora, non subito.",
  },
};

export function CalendarioPassi() {
  return (
    <Tabs defaultValue="iphone" className="mt-5">
      <TabsList className="grid grid-cols-3 w-full">
        {Object.entries(PASSI).map(([k, v]) => (
          <TabsTrigger key={k} value={k} data-testid={`cal-tab-${k}`}>{v.label}</TabsTrigger>
        ))}
      </TabsList>
      {Object.entries(PASSI).map(([k, v]) => (
        <TabsContent key={k} value={k} data-testid={`cal-steps-${k}`} className="mt-4">
          <ol className="space-y-2.5">
            {v.steps.map((s, i) => (
              <li key={i} className="flex gap-3 text-sm text-slate-700 dark:text-slate-300">
                <span className="h-6 w-6 shrink-0 rounded-full bg-primary/10 text-primary text-xs font-bold grid place-items-center">{i + 1}</span>
                <span className="pt-0.5">{s}</span>
              </li>
            ))}
          </ol>
          <p className="mt-4 text-xs text-slate-500 leading-relaxed bg-slate-50 dark:bg-slate-800/50 rounded-lg p-3">{v.extra}</p>
        </TabsContent>
      ))}
    </Tabs>
  );
}
